import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U3121Employee } from "../../../../U3121Service";
import type { U3121ProjectTimesheetAccessHandlerReturn } from "./U3121ProjectTimesheetAccessHandlers";

function displayEmployeeLabel(row: U3121Employee): string {
  if (!row) return "";
  const firstName = row.firstName ?? "";
  const lastName = row.lastName ?? "";
  const code = row.codeEmployee ?? "";
  const name = [firstName, lastName].filter(Boolean).join(" ").trim();
  return code ? `${name} (${code})` : name || row.id;
}

interface U3121ProjectTimesheetAccessDeleteDlgProps {
  handler: U3121ProjectTimesheetAccessHandlerReturn;
  t: TFunction;
  NS: string;
}

function U3121ProjectTimesheetAccessDeleteDlg({ handler, t, NS }: U3121ProjectTimesheetAccessDeleteDlgProps) {
  if (!handler.isDeleteDialogOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={handler.isDeleteDialogOpen} onClose={handler.onDlgDeleteClose} title={t("lblTimesheetAccess", { ns: NS })}>
      <p className="mb-4">
        {t("msgDeleteTimesheetAccess", {
          count: handler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {handler.gridStateHandlers.getSelectedRows().map((row: U3121Employee, index: number, array: U3121Employee[]) => (
          <span key={row.id} className="inline-block text-gray-800">
            {displayEmployeeLabel(row)}
            {index < array.length - 1 && ", "}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3121ProjectTimesheetAccessDeleteDlg;
